import script from "./SpeV2PdfDropzone.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeV2PdfDropzone.vue?vue&type=script&setup=true&lang=js"

import "./SpeV2PdfDropzone.vue?vue&type=style&index=0&id=7f1af846&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f1af846"]])

export default __exports__